import "./App.css";
import { Routes, Route } from "react-router-dom";
import { useState, useEffect, lazy, Suspense } from "react";
import { HelmetProvider } from 'react-helmet-async';
import PrototypeShell from "./pages/v2/PrototypeShell";
import { useLoading, Loader } from "./components/LoaderProvider";
import ContactV2 from "./pages/v2/ContactV2";
import FaaomptV2 from "./pages/v2/FaaomptV2";

// Lazy load components to prevent both from loading simultaneously
const HomeV2 = lazy(() => import("./pages/v2/HomeV2"));
const MobileHomePage = lazy(() => import("./pages/v2/Mobile/MobileHomeV2"));
const ServicesV2 = lazy(() => import("./pages/v2/ServicesV2"));
const MobileServicesV2 = lazy(() =>
  import("./pages/v2/Mobile/MobileServicesV2")
);
const TestimonialsV2 = lazy(() => import("./pages/v2/TestimonialsV2"));
const MobileTestimonialsV2 = lazy(() =>
  import("./pages/v2/Mobile/MobileTestimonialsV2")
);

function App() {
  // eslint-disable-next-line no-unused-vars
  const [isMobile, setIsMobile] = useState(false);
  const { isLoading } = useLoading();

  useEffect(() => {
    if (window.innerWidth <= 800) {
      setIsMobile(true);
    }
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        {isLoading && <Loader />}
        <Routes>
          <Route path="/" element={<PrototypeShell isMobile={isMobile} />}>
            <Route
              index
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  {isMobile ? <MobileHomePage /> : <HomeV2 />}
                </Suspense>
              }
            />
            <Route
              path="services"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  {isMobile ? <MobileServicesV2 /> : <ServicesV2 />}
                </Suspense>
              }
            />
            <Route
              path="testimonials"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  {isMobile ? <MobileTestimonialsV2 /> : <TestimonialsV2 />}
                </Suspense>
              }
            />
            <Route path="contact" element={<ContactV2 />} />
            <Route path="faaompt" element={<FaaomptV2 />} />
          </Route>
        </Routes>
      </div>
    </HelmetProvider>
  );
}

export default App;
